import { useCallback, useEffect, useMemo, useState } from "react";
import { SDLCReportSummary } from "@sscs/types";
import { Version } from "Types";

type VersionReportSummary = {
  reportSummary: SDLCReportSummary | null;
  hasReproBuild: boolean;
  reproAnalysisDone: boolean;
  reproIsFinal: boolean;
  showReproReport: boolean;
  toggleReport: () => void;
};

const useVersionReportSummary = (version?: Version): VersionReportSummary => {
  // Assumption is that there are exactly two risk reports, version and repro
  // If repro is final, it wins, otherwise version wins.
  // This may change with tampering theme support
  const reproIsFinal =
    version?.artifacts_summary.repro?.latest_report_summary?.scan_report
      .final === true;
  const [showReproReport, setShowReproReport] = useState(reproIsFinal);
  const reportSummary = useMemo(() => {
    if (
      showReproReport &&
      version?.artifacts_summary.repro?.latest_report_summary
    ) {
      return version.artifacts_summary.repro.latest_report_summary;
    } else {
      return version?.artifacts_summary.version.latest_report_summary;
    }
  }, [version?.artifacts_summary, showReproReport]);

  useEffect(() => {
    if (reproIsFinal) setShowReproReport(true);
  }, [reproIsFinal]);

  const toggleReport = useCallback(
    () => setShowReproReport((previous) => !previous),
    [setShowReproReport],
  );

  return {
    reproIsFinal,
    showReproReport,
    toggleReport,
    reportSummary: reportSummary ?? null,
    hasReproBuild: Boolean(version?.artifacts_summary.repro),
    reproAnalysisDone:
      version?.artifacts_summary.repro?.current_status.code === "DONE",
  };
};

export default useVersionReportSummary;
